module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/5_75e7f7486ece2d3ef12425d192740186.png";